import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import {
  // bannerimg,
  pangan,
  simpulLogo,
  kosmetik,
  obat,
  ot,
  komodity,
  kategory,
  subKategory,
  param
} from "../imagepath";
import { useSelector } from "react-redux";
// import TopCategory from "./slider/topCategory";
import Footer from "../footer";
import Select from "react-select";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import CountUp from "react-countup";
import Header2 from "../header2/index-two";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import TopCategory from "./slider/topCategory";

const options = [
  { label: "Pangan", value: 1 },
  { label: "Kosmetik", value: 2 },
  { label: "Obat", value: 3 },
  { label: "Obat Bahan Alam", value: 4 }
];

export const Home = () => {
  const [value, setValue] = useState(null);
  const [jenis, setJenis] = useState('');
  const [kate, setKate] = useState(0);
  const [subkate, setSubkate] = useState(0);
  const [par, setPar] = useState(0);
  const [loading, setLoading] = useState(false);
  const [katpangan, setKatpangan] = useState(0);
  const [katkos, setKatkos] = useState(0);
  const [katobat, setKatobat] = useState(0);
  const [katot, setKatot] = useState(0);


  const mobileSidebar = useSelector(
    (state) => state.sidebarSlice.expandMenu
  );
  
  const navigate = useNavigate();
  // const formatValue = (value) => `${Math.floor(value)}`;

  const getIndexVal = async() => {
    setLoading(true)
    try{
     
      let res = await axios.get('https://bbpom-makassar.com/api/get-index');
      setKate(res.data.kat);
      setSubkate(res.data.sub);
      setPar(res.data.par);
      setKatpangan(res.data.katpangan);
      setKatkos(res.data.katkos);
      setKatobat(res.data.katobat);
      setKatot(res.data.katot);
      setLoading(false)
    }catch(e){
      console.log(e.message);
      setLoading(false);
    }

  }
  var settings = {
    //autoWidth: true,
    items: 2,
    margin: 25,
    gap: 10,
    dots: true,
    nav: true,
    navText: [
      '<i className="fas fa-arrow-left"></i>',
      '<i className="fas fa-arrow-right"></i>',
    ],

    loop: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        margin: 25,
      },
      768: {
        items: 3,
        margin: 25,
      },
      1170: {
        items: 4,
        margin: 25,
      },
    },
  };
  const style = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor:  "#FFDEDA",
      border: state.isFocused ? 0 : 0,
      paddingLeft: "5px",
      paddingTop: "5px",
      paddingBottom: "5px",
      // This line disable the blue border
      boxShadow: state.isFocused ? 0 : 0,
      borderRadius: state.isSelected ? "0" : "10px",
      fontSize: "14px",
      "&:hover": {
        border: state.isFocused ? 0 : 0,
        color: "black",
      },
      // eslint-disable-next-line no-dupe-keys
      borderRadius: "50px",
      outline: "none",
    }),
    menu: (base) => ({ ...base, marginTop: "2px" }),
    option: (provided) => ({
      ...provided,
      backgroundColor:  mobileSidebar === 'disabled' ? "#fff" : "#000",
      color:mobileSidebar === 'disabled'? '#000':'#fff',
      fontSize: "14px",
      "&:hover": {
        backgroundColor:mobileSidebar === 'disabled'? "#FFDEDA":"#2b2838",
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: "black",
      transform: state.selectProps.menuIsOpen ? "rotate(-180deg)" : "rotate(0)",
      transition: "250ms",
    }),
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    getIndexVal()
  }, []);
  useEffect(() => {
    console.log(mobileSidebar,'gg');
  }, [mobileSidebar]);
  const handleSearch = (e) =>{
    e.preventDefault();

    // Spasi kosong saja tidak boleh lolos validasi di bawah.
    const jenisBersih = jenis ? jenis.trim() : '';

    if (!jenisBersih && !value) {
      alert("Harap isi jenis produk dan pilih komoditi!");
      return;
    }else if(!jenisBersih){
      alert("Harap mengisih jenis produk!");
      return;
    }else if(!value){
      alert("Harap memilih komoditi!");
      return;
    }
  
    // Navigasi ke komponen `subKat` dengan query parameters.
    // Wajib di-encode: tanpa ini, mencari "susu & keju" membuat jenis terpotong
    // jadi "susu " karena & memulai parameter baru, dan tanda # membuat sisa
    // alamat jadi fragment sehingga komoditi hilang sama sekali.
    const q = new URLSearchParams({ jenis: jenisBersih, komoditi: value?.value ?? '' });
    navigate(`/sub-result?${q}`);
  }
  console.log('this',katpangan)
  return (
    <>
      <div className="main-wrapper">
        <Header2 />
        {/* banner */}
        <section
          className="home-slide d-flex align-items-center"
        >
          <div className="container">
            <div className="row ">
              <div className="col-md-7">
                <div className="home-slide-face aos" data-aos="fade-up">
                  <div className="home-slide-text ">
                    <h5>&nbsp;&nbsp;&nbsp;&nbsp;Welcome...</h5>
                    <img src={simpulLogo} alt="" />
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;By BBPOM Di Makassar</p>
                  </div>
                  <div className="banner-content">
                    <form className="form" onSubmit={handleSearch}>
                      <div className="form-inner">
                        <div className="input-group homeSearch">
                          <i className="fa-solid fa-magnifying-glass search-icon" />
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Tuliskan jenis produk yang dicari"
                            onChange={(e) => setJenis(e.target.value)}
                          />
                          <span className="drop-detail">
                            <Select
                              // className="select2-container"
                              options={options}
                              value={value}
                              placeholder="Pilih Komoditi"
                              onChange={(setValue)}
                              styles={style}
                            ></Select>
                          </span>
                          <button className="btn sub-btn" type="submit">
                            <i className="fas fa-arrow-right" />
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="trust-user">
                    <p>
                    Trusted by more than hundreds of consumers <br />
                    
                    </p>
                    {/* <div className="trust-rating d-flex align-items-center">
                      <div className="rate-head">
                        <h2>
                          <span className="d-flex">
                            <CountUp
                              start={0}
                              end={1000}
                              delay={1}
                              format={formatValue}
                            />
                            +
                          </span>
                        </h2>
                      </div>
                      <div className="rating d-flex align-items-center">
                        <h2 className="d-inline-block average-rating">4.4</h2>
                        <i className="fas fa-star filled me-1" />
                        <i className="fas fa-star filled me-1" />
                        <i className="fas fa-star filled me-1" />
                        <i className="fas fa-star filled me-1" />
                        <i className="fas fa-star filled me-1" />
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="col-md-5 d-flex align-items-center">
                <div className="girl-slide-img aos" data-aos="fade-up">
                  {/* <img src={bannerimg} alt="" /> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* /banner */}

        {/* Home banner bottom */}
        {loading ? ( 
              <div style={{textAlign:'center'}}>
                <div className="spinner-border text-center" style={{ marginTop: "20px" }}></div>
              </div>  
              ) : (
        <section className="section student-course">
          <div className="container">
            <div className="course-widget">
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="course-full-width">
                    <div
                      className="blur-border course-radius align-items-center aos"
                      data-aos="fade-up"
                    >
                      <div className="online-course d-flex align-items-center">
                        <div className="course-img">
                          <img style={{width:'50px'}} src={komodity} alt="" />
                        </div>
                        <div className="course-inner-content">
                          <h4>
                            {/* <span>10</span>K */}
                            <span className="d-flex">
                              <CountUp
                                start={0}
                                end={4}
                                delay={2}
                                duration={4}
                              />
                            </span>
                          </h4>
                          <p>Komoditi</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 d-flex">
                  <div className="course-full-width">
                    <div
                      className="blur-border course-radius aos"
                      data-aos="fade-up"
                    >
                      <div className="online-course d-flex align-items-center">
                        <div className="course-img">
                          <img style={{width:'50px'}} src={kategory} alt="" />
                        </div>
                        <div className="course-inner-content">
                          <h4>
                            <span className="d-flex">
                              <CountUp start={0} end={kate} delay={1} />
                            </span>
                          </h4>
                          <p>Kategory Produk</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 d-flex">
                  <div className="course-full-width">
                    <div
                      className="blur-border course-radius aos"
                      data-aos="fade-up"
                    >
                      <div className="online-course d-flex align-items-center">
                        <div className="course-img">
                          <img style={{width:'50px'}} src={subKategory} alt="" />
                        </div>
                        <div className="course-inner-content">
                          <h4>
                            <span className="d-flex">
                              <CountUp
                                start={0}
                                end={subkate}
                                delay={1}
                                duration={5}
                              />
                            </span>
                          </h4>
                          <p>Sub Kategory</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 d-flex">
                  <div className="course-full-width">
                    <div
                      className="blur-border course-radius aos"
                      data-aos="fade-up"
                    >
                      <div className="online-course d-flex align-items-center">
                        <div className="course-img">
                          <img style={{width:'50px'}}  src={param} alt="" />
                        </div>
                        <div className="course-inner-content">
                          <h4>
                            <span className="d-flex">
                              <CountUp
                                start={0}
                                end={par}
                                delay={1}
                                duration={2}
                              />
                            </span>
                          </h4>
                          <p>Parameter Uji</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        )}
        {/* Home banner bottom */}

        {/* Top Category with Owl Carousel */}
        
        {/* <TopCategory 
          katpangan = 
        /> */}

        <section className="section how-it-works">
          <div className="container">
            <div className="section-header aos" data-aos="fade-up">
              <div className="section-sub-head">
                <h2>Komoditi</h2>
              </div>
              <div className="all-btn all-category d-flex align-items-center">
                <Link to="#" className="btn btn-primary">
                  All Commodity
                </Link>
              </div>
            </div>
            <div className="section-text aos" data-aos="fade-up">

            </div>
            {loading ? ( 
              <div style={{textAlign:'center'}}>
                <div className="spinner-border text-center" style={{ marginTop: "20px" }}></div>
              </div>  
              ) : (
              <OwlCarousel
              {...settings}
              className="owl-carousel mentoring-course owl-theme aos"
              data-aos="fade-up"
              loop
              margin={10}
              nav
              >
                <TopCategory
                  link = {'/kategory/pangan'}
                  title="Pangan"
                  image={pangan}
                  kat={katpangan}
                />
                 <TopCategory
                  link = {'/kategory/kosmetik'}
                  title="Kosmetik"
                  image={kosmetik}
                  kat={katkos}
                />
                <TopCategory
                  link = {'/kategory/obat'}
                  title="Obat"
                  image={obat}
                  kat={katobat}
                />
                <TopCategory
                  link = {'/kategory/obat-bahan-alam'}
                  title="Obat Tradis."
                  image={ot}
                  kat={katot}
                />
            </OwlCarousel>
            )}
          </div>
        </section>
        {/* Top Category with Owl Carousel */}

     

       
     

     

   


        {/* Footer */}
        <Footer />
        {/* /Footer */}
      </div>
    </>
  );
};

export default Home;
